export default {
  views: {
    invalidUrl: 'URLが無効です。',
    successToResetPassword: 'パスワードのリセットが成功しました。',
    resetPassword: 'パスワードを再設定',
    send: '送信',
    resetError:
      'パスワードリセットの有効期限が切れているか、パスワードがすでにリセットされています。',
    passwordRules: {
      title: '注記：パスワードルール',
      tips1: '文字と数字を組み合わせた8文字以上で作成ください'
    },
    enrollOTP: {
      title: '二要素認証を登録',
      code: '認証コード',
      verify: '認証'
    }
  }
};
